var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"recipes"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('Products')],1)],1),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('AccountOrders')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }